import { render, staticRenderFns } from "./TabPanelVinculos.vue?vue&type=template&id=92cf2008&scoped=true&"
import script from "./TabPanelVinculos.vue?vue&type=script&lang=js&"
export * from "./TabPanelVinculos.vue?vue&type=script&lang=js&"
import style0 from "./TabPanelVinculos.vue?vue&type=style&index=0&id=92cf2008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cf2008",
  null
  
)

export default component.exports